import Vue from "vue";
import Router from "vue-router";
import ordersRoute from "@/router/orders";
import mainRoute from "@/router/main";
import usersRoute from "@/router/users";
import servicesRoute from "@/router/services";
import joinRoute from "./join";
import myRoute from "@/router/my";
import Layout from "../../src/Layout";
import store from "@/store";
import channelTalk from "@/helpers/channelTalk";

Vue.use(Router);

const routes = [
  {
    path: "/404",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/NotFound/index.vue")
      }
    ]
  },
  {
    path: "/",
    component: Layout,
    children: mainRoute
  },
  {
    path: "/orders",
    component: Layout,
    children: ordersRoute,
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/users",
    component: Layout,
    children: usersRoute
  },
  {
    path: "/my",
    component: Layout,
    children: myRoute,
    meta: {
      requireAuth: true
    }
  },
  {
    path: "/services",
    component: Layout,
    children: servicesRoute
  },
  {
    path: "/join",
    component: Layout,
    children: joinRoute,
    beforeEnter: (to, from, next) => {
      const isAuthenticated = store.getters["auth/isAuthenticated"]();
      if (isAuthenticated) return next("/"); // 로그인 된 상태라면 메인화면으로 변경 됩니다.
      next();
    }
  },
  {
    path: "/benefits",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/Benefits/index.vue")
      }
    ]
  },
  {
    path: "*",
    redirect: "/404"
  }
];

const router = new Router({
  mode: "history",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach(async (to, from, next) => {
  channelTalk.updateReferrer(window.location.host + to.path);
  const isAuthenticated = store.getters["auth/isAuthenticated"]();
  const payload = encodeURI(to.path);
  if (to.matched.some((record) => record.meta.requireAuth)) {
    if (!isAuthenticated) {
      try {
        await store.dispatch("auth/refreshSignin", payload);
        return next();
      } catch (e) {
        return next();
      }
    }
    return next();
  }
  if (!store.state.auth.refreshToken && !store.state.auth.accessToken)
    return next();
  else {
    if (!isAuthenticated) {
      try {
        await store.dispatch("auth/refreshSignin");
        return next();
      } catch (e) {
        return next();
      }
    }
    return next();
  }
});

export default router;
